<template>
  <b-container>
    <div id="bi-main" v-html="view.embendedCode"></div>
  </b-container>
</template>
<script>
export default {
  name: "ModuleViewBi",
  props: {
    id: String,
  },
  data() {
    return {
      view: {},
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.$apiScheduler
        .get("/powerbiview/getView/" + this.id)
        .then((response) => {
          this.view = response.data;
        })
        .catch((error) => {
          if (error.response.status == 401) {
            this.$store.dispatch("logout").then(() => {
              this.$router.push("/login");
            });
          } else {
            console.log(error);
          }
        });
    },
  },
  watch: {
    id() {
      this.loadData();
    },
  },
};
</script>
<style scoped>
#bi-main {
  height: calc(100vh - 160px);
}
</style>